import { ISpotxTiers } from '~/src/dash/api/demand-settings/spotx/spotx-tiers_models';
import { createUrl, restGet, restPatch } from '~/src/dash/api/rest';
import { EBool } from '~/src/dash/api/types/bool';

export async function getSpotxTiersForPublisher(
  publisherID: string,
): Promise<[ISpotxTiers[] | undefined, Error | undefined]> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/spotx-tiers', publisherID);

  try {
    return [(await restGet<ISpotxTiers[]>(reqUrl)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}

export async function updateSpotxTiersForPublisher(
  publisherID: string,
  tiers: ISpotxTiers[],
): Promise<[ISpotxTiers[] | undefined, Error | undefined]> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/spotx-tiers', publisherID);

  try {
    return [(await restPatch<ISpotxTiers[]>(reqUrl, tiers)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}

// is enabled?
export async function getSpotxTiersEnabledForPublisher(
  publisherID: string,
): Promise<[EBool | undefined, Error | undefined]> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/spotx-tiers-enabled', publisherID);

  try {
    return [(await restGet<EBool>(reqUrl)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}

export async function updateSpotxTiersEnabledForPublisher(
  publisherID: string,
  isEnabled: EBool,
): Promise<[EBool | undefined, Error | undefined]> {
  const reqUrl = createUrl('/publishers/' + publisherID + '/spotx-tiers-enabled', publisherID);

  try {
    return [(await restPatch<EBool>(reqUrl, isEnabled)).parsedBody, undefined];
  } catch (e) {
    return [undefined, e];
  }
}
